import * as React from 'react';
import { BACKGROUND_COLOR, COLOR_A, COLOR_B, COLOR_A_RGB } from './CONSTANTS';
import { Shaders, Node, GLSL } from 'gl-react';
import { Surface } from 'gl-react-dom'; // for React DOM

class ADSRDisplayGL extends React.Component {
	constructor(props) {
		super(props);
		this.wrapperRef = React.createRef();
	}

	render() {
		const { a, d, s, r } = this.props;

		return (
			<div style={{ height: '100%', width: '100%'}} ref={this.wrapperRef}>
				{this.wrapperRef.current && (
					<Surface width={this.wrapperRef.current.offsetWidth} height={this.wrapperRef.current.offsetHeight}>
						<GL
							time={performance.now() / 200}
							width={this.wrapperRef.current.offsetWidth}
							height={this.wrapperRef.current.offsetHeight}
							a={a}
							d={d}
							s={s}
							r={r}
						/>
					</Surface>
				)}
			</div>
		);
	}
}

export default ADSRDisplayGL;

const shaders = Shaders.create({
	adsr: {
    frag: GLSL`

  precision highp float;
  varying vec2 uv;
  uniform float r,g,b;
  uniform float a,d,s,re;
  uniform float time;
  void main() {
	float totalDuration=7.;

	float ax=a/totalDuration;
	float dx=d/totalDuration;
	float rx=re/totalDuration;
	float hx=1.0/totalDuration;
	float sy=s;
	float y=uv.y*1.2;

	float amnt;
	float nd,nd2,nda,ndd,ndr,nds,alpha;
	float ip;
	vec4 cbuff = vec4(1.0);	

	float x=uv.x;

  alpha=1.;
  


	 for(float i=0.0; i<3.0;i++){
	

	nda=((x/ax))*(1.-step(ax,x));

	 ndd=(s+(1.-s)*(1.-((x-ax)/dx)))*(1.-step(ax+dx,x))*step(ax,x);
	
	
	 nds=(s)*(1.-step(ax+dx+hx,x))*step(ax+dx,x);
	 ndr=(s*(1.-(x-ax-dx-hx)/rx))/((1.))*(1.-step(ax+dx+rx+hx,x))*step(ax+dx+hx,x);


	nd=nda+nds+ndr+ndd;
	 nd=max(0.,nd);
	amnt = 1.0/abs((nd-y)/y)*0.0005;
	
	 amnt=amnt*alpha;
	 cbuff = cbuff+vec4(amnt*0.1, amnt*0.3*y , amnt*y*0.3,1.);

	nd=nd+(0.02)*nd*sin(time/10.);
	 y=y+(0.015);
	 x=x-(0.005);
	 alpha=0.85*alpha;

	}

	gl_FragColor = cbuff*vec4(1.0,1.0,1.0,1.0);
  }
  `,
	},
});

class GL extends React.Component {
	render() {
		const { time, a, d, s, r, width, height } = this.props;

		return <Node shader={shaders.adsr} uniforms={{ ...COLOR_A_RGB, time, a, d, s, re: r }} />;
	}
}
